module.exports = __webpack_public_path__ + "images/花筑奢pr长图_06-5.jpg?v=f84f656c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_06-5.jpg
 ** module id = 41
 ** module chunks = 1 2
 **/